<!--
 * @Descripttion: 
 * @FilePath: /mall-wap-vue/src/views/poster/sm/index.vue
 * @Author: 张兴业
 * @Date: 2021-06-21 18:17:16
 * @LastEditors: hl
 * @LastEditTime: 2026-03-26 14:26:05
-->
<template>
  <div class="poster">
    <div
      v-if="detail.description"
      v-html="detail.description"
      class="poster_html"
    ></div>
    <img
      v-else
      :src="
        `https://assets-img.myazstore.com/poster/sm/poster_${$route.query.id}.jpg?t=${t}`
      "
      alt=""
    />
    <div class="actions">
      <div class="title">立即开通订阅服务</div>
      <img
        src="@/assets/poster/actions_pic.png"
        alt="actions_pic.png"
        class="actions_pic"
      />
      <div class="actions_btns">
        <div v-for="(item, index) in detail.cards" :key="item.id" class="item">
          <div v-if="index === 0" class="item_c">
            <div
              :class="detail.cards.length > 1 ? 'btn btn1' : 'btn btn1 btn10'"
              @click="go(item.id)"
            >
              <span>{{ item.name }}</span>
              <span class="price">{{ $G("symbol") }}{{ item.price }}</span>
            </div>
            <div v-if="detail.cards.length > 1" class="line1"></div>
          </div>

          <div
            v-if="index > 0 && index < detail.cards.length - 1"
            class="item_c"
          >
            <div class="line21"></div>
            <div class="btn btn2" @click="go(item.id)">
              <span>{{ item.name }}</span>
              <span class="price">{{ $G("symbol") }}{{ item.price }}</span>
            </div>
            <div class="line22"></div>
          </div>

          <div
            v-if="index === detail.cards.length - 1 && detail.cards.length > 1"
            class="item_c"
          >
            <div class="line3"></div>
            <div class="btn btn3" @click="go(item.id)">
              <span>{{ item.name }}</span>
              <span class="price">¥{{ item.price }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const wx = require("jweixin-module");
import { getActivitySubById } from "@/api/poster.js";
import dayjs from "dayjs";

export default {
  data() {
    return {
      detail: {
        cards: []
      },
      t: dayjs().unix()
    };
  },
  mounted() {
    this.getActivitySubById();
  },
  methods: {
    getActivitySubById() {
      getActivitySubById({
        id: this.$route.query.id
      })
        .then(res => {
          console.log(res);
          if (res.code === 1) {
            this.detail = res.data;
          }
        })
        .catch(() => {});
    },
    isApp() {
      const regx = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|android)/i;
      if (navigator.userAgent.match(regx)) {
        return true;
      }
      return false;
    },
    isWechatBrowser: function() {
      var ua = navigator.userAgent.toLowerCase();
      var isWeixin = ua.indexOf("micromessenger") !== -1;
      return isWeixin;
    },
    go(id) {
      if (this.isWechatBrowser()) {
        // this.$toast("isWechatBrowser");
        // const _this = this;
        wx.miniProgram.getEnv(function(res) {
          if (res.miniprogram) {
            // _this.$toast("miniProgram" + id);
            // 走在小程序的逻辑
            // wx.miniProgram.postMessage({ id });
            wx.miniProgram.navigateTo({
              url: encodeURI(
                `/pages/orderpay/orderpay?form=zhouqihuodongka&carryData={"id":${id}}`
              )
            });
          } else {
            // 走不在小程序的逻辑
            // _this.$toast("isWechatBrowser but not miniProgram");
          }
        });
      } else {
        if (this.isApp()) {
          // this.$toast("isApp" + id);
          // eslint-disable-next-line no-undef
          PosterSM.postMessage(id);
        } else {
          // this.$toast("not isApp" + id);
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.poster {
  padding-bottom: 96px;
  .poster_html {
    ::v-deep img {
      width: 100% !important;
      display: block !important;
    }
  }

  img {
    width: 100%;
    display: block;
  }

  // ::v-deep p {
  //   margin: 0;
  // }
}

.actions {
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  height: 120px;
  background: white;
  font-size: 12px;
  font-weight: 500;

  .title {
    text-align: left;
    padding: 16px;
  }

  .actions_pic {
    position: absolute;
    right: 0;
    top: -18px;
    width: 95px;
    z-index: -2;
    display: block;
  }

  .actions_btns {
    display: flex;
    padding: 0 12px;

    .item {
      flex: 1;

      .item_c {
        display: flex;
      }
    }
  }

  .btn {
    background: linear-gradient(180deg, #ebc886, #ffffff 100%);
    height: 36px;
    line-height: 36px;
    text-align: center;

    .price {
      color: #fd2824;
      font-weight: 95 ExtraBold;
      margin-left: 2px;
    }
  }

  .btn1 {
    border-top: 0.5px solid #000000;
    border-left: 0.5px solid #000000;
    border-bottom: 0.5px solid #000000;
    border-top-left-radius: 18px;
    border-bottom-left-radius: 18px;
    position: relative;
    flex: 1;
  }

  .btn10 {
    border-right: 0.5px solid #000000;
    border-radius: 18px;
  }

  .line1 {
    height: 36px;
    position: relative;
    margin-right: 20px;
  }

  .line1::before {
    position: absolute;
    content: "";
    width: 13.1px;
    height: 36px;
    // background: #000;
    position: absolute;
    // background: red;
    z-index: -1;
    top: 0;
    transform-origin: left top;
    transform: skewX(-20deg);
    border-right: 0.5px solid #000;
    border-top: 0.5px solid #000;
    background: linear-gradient(180deg, #ebc886, #ffffff 100%);
  }

  .btn2 {
    // margin: 0 30px;
    position: relative;
    border-top: 0.5px solid #000;
    border-bottom: 0.5px solid #000;
    flex: 1;
  }

  .line21 {
    height: 36px;
    position: relative;
  }

  .line21::before {
    position: absolute;
    content: "";
    width: 13.1px;
    height: 36px;
    // background: #000;
    position: absolute;
    // background: red;
    z-index: -1;
    top: -0.2px;
    transform-origin: left top;
    transform: skewX(-20deg);
    border-bottom: 0.5px solid #000;
    border-left: 0.5px solid #000;
    background: linear-gradient(180deg, #ebc886, #ffffff 100%);
  }

  .line22 {
    height: 36px;
    position: relative;
    margin-right: 20px;
  }

  .line22::before {
    position: absolute;
    content: "";
    width: 13.1px;
    height: 36px;
    // background: #000;
    position: absolute;
    // background: red;
    z-index: -1;
    top: 0;
    transform-origin: left top;
    transform: skewX(-20deg);
    border-right: 0.5px solid #000;
    border-top: 0.5px solid #000;
    background: linear-gradient(180deg, #ebc886, #ffffff 100%);
  }

  .btn3 {
    border-top: 0.5px solid #000;
    border-bottom: 0.5px solid #000;
    border-right: 0.5px solid #000;
    border-top-right-radius: 18px;
    border-bottom-right-radius: 18px;
    flex: 1;
  }

  .line3 {
    height: 36px;
    position: relative;
  }

  .line3::before {
    position: absolute;
    content: "";
    width: 13.1px;
    height: 36px;
    // background: #000;
    position: absolute;
    // background: red;
    z-index: -1;
    top: -0.2px;
    transform-origin: left top;
    transform: skewX(-20deg);
    border-left: 0.5px solid #000;
    border-bottom: 0.5px solid #000;
    background: linear-gradient(180deg, #ebc886, #ffffff 100%);
  }
}
</style>
